export class LoginModel {
    grant_type = 'password';
    username =  '';
    password =  '';
    otpPassword = '';
    institution =  '';
}
